export default __webpack_public_path__ + "static/media/loading-white.93c12adf.svg";